import React, { useEffect } from "react";
import { Card, Spinner } from "react-bootstrap";
import { INote } from "../../../Shared/Interfaces";
import { getLocalDate, getLocalTime } from "../../../utils/formatValue";
import { StyledCard } from "./styles";
import { MdPrint } from "react-icons/md";
import { api } from "../../../services/api";
import { useQuery } from "@tanstack/react-query";

interface IProps {
  idiproc?: string | number;
  codprod?: string | number;
  axiosConfig: any;
  onNotesLoaded?: (notes: INote[]) => void;
  handlePrint?: (nuapo: string) => void;
}

export default function NotesHistory({
  idiproc,
  codprod,
  axiosConfig,
  onNotesLoaded,
  handlePrint,
}: IProps) {
  const notesQuery = useQuery({
    queryKey: ["findProductNoteHistory", idiproc, codprod],
    enabled: Boolean(idiproc && codprod),
    staleTime: 30_000,
    refetchOnMount: false,
    queryFn: async () => {
      const response = await api.get(
        `findProductNoteHistory?IDIPROC=${idiproc}&CODPROD=${codprod}`,
        axiosConfig
      );

      return (response?.data || []) as INote[];
    },
  });

  const notes = notesQuery.data || [];
  const loading = notesQuery.isFetching;

  useEffect(() => {
    onNotesLoaded?.(notes);
  }, [notes, onNotesLoaded]);

  return (
    <div>
      <StyledCard text={"dark"} bg={"Light"} className="mb-2">
        <Card.Body>
          <Card.Header>
            <span>Apontamentos Realizados</span>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "220px",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th style={{ paddingRight: "5px" }}>Data</th>
                    <th style={{ paddingRight: "5px" }}>Usuário</th>
                    <th style={{ paddingRight: "5px" }}>Apontamento</th>
                    <th>Quantidade</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {notes.map((note: INote, idx: number) => (
                    <tr key={idx}>
                      <td style={{ paddingRight: "5px" }}>
                        {getLocalDate(note?.DHAPO?.toString())}{" "}
                        {getLocalTime(note?.DHAPO)}
                      </td>
                      <td style={{ paddingRight: "5px" }}>{note.CODUSU}</td>
                      <td style={{ paddingRight: "5px" }}>{note.NUAPO}</td>
                      <td>{note.QTDEPROD}</td>
                      <td>
                        {handlePrint && (
                          <MdPrint
                            size={24}
                            style={{ cursor: "pointer" }}
                            onClick={() => handlePrint(note?.NUAPO.toString())}
                            color={"#dd5400"}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Body>
        </Card.Body>
      </StyledCard>
    </div>
  );
}
